// Monday, 10 August 2026
// Change this version if you want to invalidate old data
export const DATA_VERSION = '1786233600';
